import { combineReducers } from "redux";
import companies from "./companies";
import responses from "./responses";
import responseTabs from "./responseTabs";
export default combineReducers({
    companies,
    responses,
    responseTabs,
});
